"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var md5_1 = __importDefault(require("md5"));
var util_1 = require("../util");
var ext_1 = require("../util/ext");
var service_1 = __importDefault(require("../util/service"));
var ExtError_1 = require("./ExtError");
var ExtUserAuth_1 = __importDefault(require("../ext/ExtUserAuth"));
var sharedInstanceMap = new Map();
/**
 * 小程序SDK功能提供者，可以用其同名的实例方法处理frameMessage的请求
 */
var ExtFunctionalProvider = /** @class */ (function () {
    function ExtFunctionalProvider(logger, extMain, extEndpoint, modalContainer) {
        this.logger = logger;
        this.extMain = extMain;
        this.extEndpoint = extEndpoint;
        this.modalContainer = modalContainer;
        this.userAuth = ExtUserAuth_1["default"].getInstance(this.logger, this.extMain);
        var k = extMain.extUuid + "_" + extEndpoint.extType;
        if (!sharedInstanceMap.get(k)) {
            sharedInstanceMap.set(k, this);
        }
    }
    /**
     * 获取共享实例
     * @param logger logger
     * @param extMain 小程序主体信息
     * @param extEndpoint 小程序endpoint信息
     * @param modalContainer 弹窗容器
     */
    ExtFunctionalProvider.getSharedInstance = function (logger, extMain, extEndpoint, modalContainer) {
        var k = extMain.extUuid + "_" + extEndpoint.extType;
        var Ctor = this;
        if (!sharedInstanceMap.get(k)) {
            return new Ctor(logger, extMain, extEndpoint, modalContainer);
        }
        else {
            return sharedInstanceMap.get(k);
        }
    };
    /**
     * request接口的实现（供参考）
     * @param req request接口的请求
     * @param adapter 小程序适配器
     */
    ExtFunctionalProvider.prototype.request = function (req, adapter) {
        return __awaiter(this, void 0, void 0, function () {
            var jwt, header, url, method, data, dataType, tafRsp, _a, entity, statusCode, rspHeader, rspData;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ExtUserAuth_1["default"].getInstance(this.logger, this.extMain).getAuth(adapter, this.extEndpoint, this.modalContainer)];
                    case 1:
                        jwt = (_b.sent()).jwt;
                        header = req.header, url = req.url, method = req.method, data = req.data, dataType = req.dataType;
                        if (!(!ext_1.isDev(this.extMain) || !req.isDirect)) return [3 /*break*/, 3];
                        return [4 /*yield*/, service_1["default"].routeEbsRequestV2(adapter, this.extMain, this.extEndpoint, jwt, header, url, method, data)];
                    case 2:
                        tafRsp = _b.sent();
                        _a = tafRsp.ebsResponse, entity = _a.entity, statusCode = _a.statusCode, rspHeader = _a.header;
                        rspData = entity;
                        if (dataType !== 'text') {
                            try {
                                rspData = JSON.parse(util_1.unescapeHTML(entity));
                            }
                            catch (_) {
                                throw new ExtError_1.ExtInvalidOutputError('返回的JSON解析错误');
                            }
                        }
                        return [2 /*return*/, { data: rspData, statusCode: Number(statusCode), header: rspHeader.value }];
                    case 3: return [2 /*return*/, adapter.requestWithoutProxy(jwt, header, url, method, data, dataType)];
                }
            });
        });
    };
    ExtFunctionalProvider.prototype.getItem = function (req, adapter) {
        return __awaiter(this, void 0, void 0, function () {
            var key, jwt, tafRsp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        key = req.key;
                        if (!(typeof key === 'undefined' || !String(key))) return [3 /*break*/, 1];
                        return [2 /*return*/, Promise.reject(new ExtError_1.ExtParamInvalidError('key不能为空'))];
                    case 1: return [4 /*yield*/, this.userAuth.getAuth(adapter, this.extEndpoint, this.modalContainer)];
                    case 2:
                        jwt = (_a.sent()).jwt;
                        return [4 /*yield*/, service_1["default"].getStorageKey(adapter, this.extMain, this.extEndpoint, key, jwt)];
                    case 3:
                        tafRsp = _a.sent();
                        return [2 /*return*/, util_1.unescapeHTML(tafRsp.dataValue)];
                }
            });
        });
    };
    ExtFunctionalProvider.prototype.setItem = function (req, adapter) {
        return __awaiter(this, void 0, void 0, function () {
            var key, value, lUid, jwt;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        key = req.key, value = req.value;
                        return [4 /*yield*/, adapter.getUserId()];
                    case 1:
                        lUid = (_a.sent()).lUid;
                        if (!(lUid === adapter.getStreamerUid())) return [3 /*break*/, 7];
                        if (!(typeof key === 'undefined' || !String(key))) return [3 /*break*/, 2];
                        return [2 /*return*/, Promise.reject(new ExtError_1.ExtParamInvalidError('key不能为空'))];
                    case 2:
                        if (!(typeof key === 'undefined' || !String(value))) return [3 /*break*/, 3];
                        return [2 /*return*/, Promise.reject(new ExtError_1.ExtParamInvalidError('value不能为空'))];
                    case 3: return [4 /*yield*/, this.userAuth.getAuth(adapter, this.extEndpoint, this.modalContainer)];
                    case 4:
                        jwt = (_a.sent()).jwt;
                        return [4 /*yield*/, service_1["default"].setStorage(adapter, this.extMain, this.extEndpoint, key, value, jwt)];
                    case 5:
                        _a.sent();
                        return [2 /*return*/, Promise.resolve()];
                    case 6: return [3 /*break*/, 8];
                    case 7: return [2 /*return*/, Promise.reject(new ExtError_1.ExtNotSupportError('这个接口仅支持主播调用'))];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    ExtFunctionalProvider.prototype.getKeys = function (_, adapter) {
        return __awaiter(this, void 0, void 0, function () {
            var lUid, jwt, tafRsp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, adapter.getUserId()];
                    case 1:
                        lUid = (_a.sent()).lUid;
                        if (!(lUid === adapter.getStreamerUid())) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.userAuth.getAuth(adapter, this.extEndpoint, this.modalContainer)];
                    case 2:
                        jwt = (_a.sent()).jwt;
                        return [4 /*yield*/, service_1["default"].getStorageAllKeys(adapter, this.extMain, this.extEndpoint, jwt)];
                    case 3:
                        tafRsp = _a.sent();
                        return [2 /*return*/, Promise.resolve(tafRsp.dataKeys.value)];
                    case 4: return [2 /*return*/, Promise.reject(new ExtError_1.ExtNotSupportError('这个接口仅支持主播调用'))];
                }
            });
        });
    };
    ExtFunctionalProvider.prototype.removeItem = function (req, adapter) {
        return __awaiter(this, void 0, void 0, function () {
            var key, lUid, jwt;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        key = req.key;
                        return [4 /*yield*/, adapter.getUserId()];
                    case 1:
                        lUid = (_a.sent()).lUid;
                        if (!(lUid === adapter.getStreamerUid())) return [3 /*break*/, 6];
                        if (!(typeof key === 'undefined' || !String(key))) return [3 /*break*/, 2];
                        return [2 /*return*/, Promise.reject(new ExtError_1.ExtParamInvalidError('key不能为空'))];
                    case 2: return [4 /*yield*/, this.userAuth.getAuth(adapter, this.extEndpoint, this.modalContainer)];
                    case 3:
                        jwt = (_a.sent()).jwt;
                        return [4 /*yield*/, service_1["default"].delStorageKey(adapter, this.extMain, this.extEndpoint, key, jwt)];
                    case 4:
                        _a.sent();
                        return [2 /*return*/, Promise.resolve()];
                    case 5: return [3 /*break*/, 7];
                    case 6: return [2 /*return*/, Promise.reject(new ExtError_1.ExtNotSupportError('这个接口仅支持主播调用'))];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    ExtFunctionalProvider.prototype.uploadImg = function (_, adapter) {
        return __awaiter(this, void 0, void 0, function () {
            var jwt, inputFile;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.userAuth.getAuth(adapter, this.extEndpoint, this.modalContainer)];
                    case 1:
                        jwt = (_a.sent()).jwt;
                        inputFile = document.createElement('input');
                        inputFile.setAttribute('type', 'file');
                        inputFile.setAttribute('accept', 'image/png,image/jpg,image/gif,image/jpeg');
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                var handler = function () {
                                    var file = inputFile.files[0];
                                    if (file) {
                                        var maxPackageSize = (_this.extEndpoint.typeAuthority.apiAuthority.value.find(function (a) { return a.apiName === 'hyExt.fs.uploadImg'; }) || {}).maxPackageSize;
                                        var maxImgSize = Number(maxPackageSize) >= 0
                                            ? maxPackageSize * 1024
                                            : ext_1.MAX_IMG_SIZE;
                                        if (file.size > maxImgSize) {
                                            return reject(new ExtError_1.ExtParamInvalidError('上传文件不能超过' + parseInt(String(maxImgSize / 1024), 10) + 'KB'));
                                        }
                                        else {
                                            var fileExt_1 = '.' + file.name.split('.').pop();
                                            var fileReader = new window.FileReader();
                                            fileReader.onload = function (evt) { return __awaiter(_this, void 0, void 0, function () {
                                                var contentMD5, rsp, formData, request;
                                                return __generator(this, function (_a) {
                                                    switch (_a.label) {
                                                        case 0:
                                                            contentMD5 = md5_1["default"](evt.target.result);
                                                            return [4 /*yield*/, service_1["default"].getPicUploadPolicy(adapter, this.extMain, this.extEndpoint, jwt)];
                                                        case 1:
                                                            rsp = _a.sent();
                                                            formData = new window.FormData();
                                                            formData.append('key', rsp.uploadDir + contentMD5.slice(0, 16) + fileExt_1);
                                                            formData.append('policy', rsp.policy);
                                                            formData.append('OSSAccessKeyId', rsp.accessId);
                                                            formData.append('success_action_status', '200');
                                                            formData.append('callback', rsp.callback);
                                                            formData.append('signature', rsp.signature);
                                                            formData.append('file', file);
                                                            request = new XMLHttpRequest();
                                                            request.open('POST', rsp.uploadHost);
                                                            request.onreadystatechange = function () {
                                                                if (request.readyState === XMLHttpRequest.DONE) {
                                                                    if (request.status === 200) {
                                                                        var json = JSON.parse(request.responseText);
                                                                        if (json && json.status === 0) {
                                                                            resolve({ url: json.data.fileUrl });
                                                                        }
                                                                        else {
                                                                            reject(new ExtError_1.ExtInternalError((json && json.msg) ? json.msg : '上传错误，请联系管理员'));
                                                                        }
                                                                    }
                                                                    else {
                                                                        reject(new ExtError_1.ExtInternalError('上传错误，请联系管理员'));
                                                                    }
                                                                }
                                                            };
                                                            request.send(formData);
                                                            return [2 /*return*/];
                                                    }
                                                });
                                            }); };
                                            fileReader.readAsArrayBuffer(file);
                                        }
                                    }
                                    inputFile.remove();
                                };
                                inputFile.addEventListener('change', handler);
                                inputFile.click();
                            })];
                }
            });
        });
    };
    ExtFunctionalProvider.prototype.getJWT = function (_, adapter) {
        return __awaiter(this, void 0, void 0, function () {
            var jwt;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.userAuth.getAuth(adapter, this.extEndpoint, this.modalContainer)];
                    case 1:
                        jwt = (_a.sent()).jwt;
                        return [2 /*return*/, Promise.resolve({ jwt: jwt })];
                }
            });
        });
    };
    ExtFunctionalProvider.prototype.getVersionType = function (_, adapter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, Promise.resolve({ versionType: this.extMain.extVersionType })];
            });
        });
    };
    ExtFunctionalProvider.prototype.getExtInfo = function (_, adapter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, Promise.resolve({
                        extUuid: this.extMain.extUuid,
                        extName: this.extMain.extName,
                        extVersion: this.extMain.extVersion,
                        extVersionType: this.extMain.extVersionType,
                        extLogo: this.extMain.extVersionDetail.extLogo,
                        extIcon: this.extMain.extVersionDetail.extIcon,
                        extType: this.extEndpoint.extType
                    })];
            });
        });
    };
    ExtFunctionalProvider.prototype.reportText = function (req, adapter) {
        return __awaiter(this, void 0, void 0, function () {
            var tafRsp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(req && req.text)) return [3 /*break*/, 2];
                        return [4 /*yield*/, service_1["default"].textReportSDKFormExt(adapter, this.extMain, req.text)];
                    case 1:
                        tafRsp = _a.sent();
                        if (tafRsp.ret === 1) {
                            return [2 /*return*/, Promise.resolve()];
                        }
                        else {
                            return [2 /*return*/, Promise.reject(new ExtError_1.ExtInternalError(tafRsp.msg))];
                        }
                        return [3 /*break*/, 3];
                    case 2: return [2 /*return*/, Promise.reject(new ExtError_1.ExtParamInvalidError('必须传入text参数'))];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ExtFunctionalProvider.prototype.commonQuery = function (req, adapter) {
        return __awaiter(this, void 0, void 0, function () {
            var key, param, jwt, tafRsp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        key = req.key, param = req.param;
                        return [4 /*yield*/, this.userAuth.getAuth(adapter, this.extEndpoint, this.modalContainer)];
                    case 1:
                        jwt = (_a.sent()).jwt;
                        return [4 /*yield*/, service_1["default"].commonBusiness(adapter, this.extMain, this.extEndpoint, key, JSON.stringify(param), jwt)];
                    case 2:
                        tafRsp = _a.sent();
                        return [2 /*return*/, Promise.resolve(JSON.parse(util_1.unescapeHTML(tafRsp.responseJson)))];
                }
            });
        });
    };
    return ExtFunctionalProvider;
}());
exports["default"] = ExtFunctionalProvider;
